module.exports = __webpack_public_path__ + "media/EXIT_STEEZ_Interstellar_MIXMD_V.03.3503123e.mp3";